<template>
  <div class="clue-form">
    <div
      v-if="
        (!isAppEnv && !optionsData.city) ||
          (isAppEnv && !appLocation.lat && !appLocation.lng) ||
          hasThisField('area')
      "
      class="ph-box"
      @click="openCity"
    >
      <input
        v-model="optionsData.address"
        class="ph-input input-address"
        maxlength="11"
        disabled
        pattern="[0-9]*"
        placeholder="请选择您的城市"
      />
    </div>
    <div class="ph-box">
      <input
        v-model="optionsData.phone"
        class="ph-input hll-phone"
        maxlength="11"
        pattern="[0-9]*"
        placeholder="请输入手机号"
      />
      <div
        v-show="optionsData.phone"
        @click="optionsData.phone = ''"
        class="input-right-close"
        style="display: none;"
      >
        <i class="icon-bg input-close"></i>
      </div>
    </div>
    <div class="ph-box name-box" v-if="hasThisField('name')">
      <input
        v-model="optionsData.name"
        class="ph-input hll-phone"
        maxlength="15"
        placeholder="请输入姓名"
      />
    </div>
    <div class="captcha-box" v-if="hasThisField('sms')">
      <input
        v-model="optionsData.captcha"
        class="input-captcha"
        maxlength="6"
        placeholder="请输入验证码"
      />
      <button
        class="btn-get-captcha"
        :disabled="!btnGetCaptchaClickable"
        :class="{
          'btn-get-captcha-disabled': !btnGetCaptchaClickable
        }"
        @click="handleClickBtnGetCaptcha"
      >
        {{ btnGetCaptchaText }}
      </button>
    </div>
  </div>
</template>

<script>
import { getUrlParam } from "@/utils/util";
import api from "@/api";
export default {
  name: "clueForm",
  props: ["optionsData", "appLocation", "isAppEnv", "want", "configData"],
  data() {
    return {
      btnGetCaptchaText: "获取验证码",
      count: 60,
      requesting: false,
      mode: getUrlParam("mode")
    };
  },
  computed: {
    btnGetCaptchaClickable() {
      const r =
        this.count === 60 &&
        this.optionsData.phone.length === 11 &&
        !this.requesting;
      return r;
    },
    hasThisField() {
      return function(field) {
        if (this.configData) {
          return this.configData.fields.includes(field);
        }
      };
    }
  },
  methods: {
    getCaptcha() {
      this.requesting = true;
      api
        .getCaptcha(this.optionsData.phone)
        .then(res => {
          if (res.data.code === 0) {
            this.$toast.success("已发送，请注意查收短信");
            this.setCountdown();
            this.requesting = false;
          } else {
            this.requesting = false;
            this.$toast({
              message: res.data.msg
            });
          }
        })
        .catch(() => {
          this.requesting = false;
          this.$toast({
            message: "网络不给力"
          });
        });
    },
    handleClickBtnGetCaptcha() {
      if (!this.btnGetCaptchaClickable) {
        return;
      }
      this.getCaptcha();
    },
    openCity() {
      this.$emit("openCity");
    },
    setCountdown() {
      this.count -= 1;
      setTimeout(() => {
        if (this.count >= 1) {
          this.btnGetCaptchaText = `${this.count}s`;
          this.setCountdown();
        } else {
          this.count = 60;
          this.btnGetCaptchaText = "获取验证码";
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/css/rpx.scss";
.clue-form {
  .ph-box {
    position: relative;
    text-align: center;
    background: #f4f4f4;
    margin-bottom: rpx(24);
    height: rpx(96);
    border-radius: rpx(50);
    width: 100%;
    overflow: hidden;
    .input-right-close {
      position: absolute;
      width: rpx(60);
      height: rpx(60);
      top: 0;
      right: rpx(10);
      bottom: 0;
      margin: auto;
      z-index: 30;
      .input-close {
        position: absolute;
        width: rpx(24);
        height: rpx(24);
        top: 0;
        right: rpx(10);
        bottom: 0;
        margin: auto;
        width: rpx(24);
        height: rpx(24);
        background: url("~@/assets/img/input-close.png") no-repeat;
        background-size: rpx(24) rpx(24);
        z-index: 30;
      }
    }
    .ph-input {
      padding: rpx(28) 0;
      background: #f4f4f4;
      width: 100%;
      border: none;
      text-indent: rpx(30);
      font-size: rpx(34);
      line-height: rpx(40);
      transition: all 0.3s;
    }
  }
  .input-address:disabled {
    color: #000;
    opacity: 1;
    -webkit-text-fill-color: #000;
  }
  .captcha-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: rpx(30);
    .input-captcha {
      border: none;
      background: #f4f4f4;
      border-radius: rpx(40);
      padding: rpx(20) rpx(30);
      font-size: rpx(36);
      max-width: rpx(400);
    }
    .btn-get-captcha {
      padding: rpx(10);
      font-size: rpx(32);
      min-width: rpx(200);
      background: #fd960b;
      color: #fff;
      border: none;
      border-radius: rpx(16);
    }
    .btn-get-captcha-disabled {
      background: #d3d1cf;
    }
  }
}
</style>
